export default __webpack_public_path__ + "static/media/top.5dda1089.png";